export const CURRICULUM_PROVIDER_TEXAS = 'Lubbock';
export const CURRICULUM_PROVIDER_FLORIDA = 'Pinellas';
